import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc/api-utils';
import { authFactory, urlApiFactory } from '../model/factory';

export const PATHNAME = '/api/MyAssociation/Summary';

export const schema = manageSchema.pick({
  envJWTToken: true,
  eventGroups: true,
  hostApi: true,
  societyShort: true,
}).required();

export const fetchGet = (params) => async () => {
  const prms = schema.parse(params);
  const url = urlApiFactory(prms);
  url.pathname = PATHNAME;
  url.searchParams.append('shortName', prms.societyShort);
  url.searchParams.append('eventGroups', prms.eventGroups);
  const headers = {
    Authorization: authFactory(prms)
  };

  const req = new Request(url, { headers });
  return fetch(req)
    .then(assertOk)
    .then(takeData);
};
